import { colors, getHeight, getSpacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';

import { StyledMenuProps } from './types';

export const StyledMenu = styled.div<StyledMenuProps>`
  position: absolute;
  top: ${(props) => (props.isMobile ? getHeight('xl') : getHeight('l'))};
  left: 0px;
  height: ${(props) =>
    props.isMobile
      ? `calc(100vh - ${getHeight('xl')})`
      : `calc(100vh - ${getHeight('l')})`};
  width: 100%;
  background-color: ${colors.white};
  z-index: 1;
  padding: ${getSpacing('m')};
`;

export const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  height: ${getHeight('m')};
  display: flex;
  align-items: center;
  gap: ${getSpacing('xxs')};
`;

export const StyledLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSpacing('xxs')};
`;

export const StyledHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${getSpacing('s')};
`;

export const StyledRotatedRouteIconWrapper = styled.span`
  display: inline-flex;
  transform: rotate(90deg);
`;
